import type { ChartConfig } from "@/components/ui/chart";

export type TaskMemberMetricsRow = {
  name: string;
  completed: number;
  positive: number;
  negative: number;
  overdue: number;
};

export const taskMemberMetricsChartConfig = {
  completed: {
    label: "Concluídas",
    theme: {
      light: "hsl(262 75% 55%)",
      dark: "hsl(262 70% 70%)",
    },
  },
  positive: {
    label: "Positivas",
    theme: {
      light: "hsl(142 60% 38%)",
      dark: "hsl(142 55% 55%)",
    },
  },
  negative: {
    label: "Negativas",
    theme: {
      light: "hsl(0 72% 51%)",
      dark: "hsl(0 62% 55%)",
    },
  },
  overdue: {
    label: "Atrasadas",
    theme: {
      light: "hsl(38 92% 50%)",
      dark: "hsl(38 85% 58%)",
    },
  },
} satisfies ChartConfig;

export function taskMemberChartHeight(memberCount: number): number {
  return Math.max(280, Math.min(520, memberCount * 56 + 80));
}
